import Lenis from 'lenis';

import { gsap, ScrollTrigger } from './gsap';
import { prefersReducedMotion } from './motion';

let lenis = null;

export const initSmoothScroll = () => {
  if (prefersReducedMotion) return () => {};

  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  const raf = (time) => lenis.raf(time * 1000);

  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(raf);
  gsap.ticker.lagSmoothing(0);

  return () => {
    gsap.ticker.remove(raf);
    lenis.destroy();
    lenis = null;
  };
};

// Accepts a selector, an element or a Y position
export const scrollToTarget = (target, { offset = 0, duration = 1.5, onComplete } = {}) => {
  if (lenis) {
    // Page height may have just changed (route change), refresh the scroll limit first
    lenis.resize();
    lenis.scrollTo(target, { offset, duration, onComplete });
    return;
  }

  const element = typeof target === 'string' ? document.querySelector(target) : target;
  const top = typeof target === 'number' ? target : element.getBoundingClientRect().top + window.scrollY + offset;

  window.scrollTo({ top, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  if (onComplete) setTimeout(onComplete, prefersReducedMotion ? 0 : 900);
};

export const resetScroll = () => {
  if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
  else window.scrollTo(0, 0);
};

export const stopScroll = () => lenis?.stop();

export const startScroll = () => lenis?.start();
